import { render, staticRenderFns } from "./AgreementUserRow.vue?vue&type=template&id=2480d362&scoped=true&"
import script from "./AgreementUserRow.vue?vue&type=script&lang=js&"
export * from "./AgreementUserRow.vue?vue&type=script&lang=js&"
import style0 from "./AgreementUserRow.vue?vue&type=style&index=0&id=2480d362&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480d362",
  null
  
)

export default component.exports